import { render } from "./Funcoes.vue?vue&type=template&id=d3b20948"
import script from "./Funcoes.vue?vue&type=script&lang=js"
export * from "./Funcoes.vue?vue&type=script&lang=js"

import "./Funcoes.vue?vue&type=style&index=0&id=d3b20948&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__